import React from 'react';

import PropTypes from 'prop-types';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import styled from 'styled-components';

import { getColorFromKey } from 'constants/helper';

const StyledChartContainer = styled.div`
  display: flex;
  padding-bottom: 1rem;
`;

const SpiderChart = ({
  data,
  LabelDetails,
  domain = [0, 5],
  RadarProps: {
    maxHeight = 400,
    width = '100%',
    aspectRatio = 1,
    tick = false,
    axisLine = false,
    legendType = 'circle',
  } = {},
}) => (
  <StyledChartContainer>
    <ResponsiveContainer maxHeight={maxHeight} width={width} aspect={aspectRatio}>
      <RadarChart cx="50%" cy="50%" style={{ height: '100%', width: '100%' }} outerRadius="80%" data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="label" />
        <PolarRadiusAxis angle={30} domain={domain} tick={tick} axisLine={axisLine} />
        {LabelDetails &&
          LabelDetails.map((item) => (
            <Radar
              name={item.description}
              dataKey={item.key}
              stroke={getColorFromKey(item.color)}
              fill={getColorFromKey(item.color)}
              fillOpacity={0.5}
              legendType={legendType}
            />
          ))}
        <Tooltip />
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  </StyledChartContainer>
);

SpiderChart.propTypes = {
  SpiderChartProps: PropTypes.shape({
    LabelDetails: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        maxRating: PropTypes.number.isRequired,
      }).isRequired
    ).isRequired,
    domain: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  }).isRequired,
};

export default SpiderChart;
